// Templates de checklist (infraestrutura/instalação) que não representam uma casa —
// não fazem sentido unir a uma unidade do SAP. Espelha
// CRUDQMAConsulta.TemplatesSemVinculoSapObrigatorio no back.
export const TEMPLATES_SEM_VINCULO_SAP = ['LV.OBR.038.Q', 'LV.OBR.037.Q']

export function exigeVinculoSap (codigoQMATemplate) {
  return !TEMPLATES_SEM_VINCULO_SAP.includes(codigoQMATemplate)
}



// WEBPACK FOOTER //
// ./src/shared/utils/qmaTemplate.js